import React, {useState} from 'react';
import './addProjectPopups.scss';
import {request} from "../../../../api/request";

const EditProjectPopup = ({ onClose,fetchMatrix, toEdit, setToEdit}) => {
    const [initialState, setInitialState] = useState(toEdit);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState("");
    const handleChange = (e) => {
        setToEdit({ ...toEdit, [e.target.name]: e.target.value });
    };

    const [changed, setChanged] = useState()
    const handlesend = async (data) => {
        await request
            .patch(
                `/donors/matrixaction/update/${data.id}`,
                data,
                {
                    headers: {
                        "api-token": "p12378",
                        "Authorization" : `Bearer ${localStorage.getItem("dToken")}`
                    }
                }
            )
            .then((res) => {
                setMessage("Saved successfully!");
                setMessageType("success");
                setInitialState(toEdit)
                fetchMatrix()
            })
            .catch((err) => {
                setMessage(err.response?.data?.message || "An unknown error occurred.!");
                setMessageType("error");
                console.log(err.response)
            });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        handlesend(toEdit)
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="closer-btn" onClick={()=>onClose()}>&times;</button>
                <h2>Update Project</h2>
                {message && (
                    <div className={`message ${messageType}`}>
                        {message}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-6">

                            <div className="form-group row">
                                <label htmlFor="order" className="col-2 col-form-label">
                                    <span>Order</span>
                                </label>
                                <div className="col-10">
                                    <input id="order" value={toEdit.number||''} className="form-control" name="number" type="number" onChange={handleChange} max={99} style={{width:"200px"}}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="direction" className="col-2 col-form-label">
                                    <span>Direction</span>
                                </label>
                                <div className="col-10">
                                    <select
                                        name="direction"
                                        id="direction"
                                        className="form-control"
                                        onChange={handleChange}
                                        style={{width:'max-content'}}
                                        defaultValue={toEdit.directions||''}
                                        required
                                    >
                                        <option value='WATER SUPPLY AND SANITATION'>WATER SUPPLY AND SANITATION</option>
                                        <option value='WATER RESOURCES MANAGEMENT'>WATER RESOURCES MANAGEMENT</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="project_title" className="col-2 col-form-label">
                                    <span>Project Title and Description (Goal/Outcomes/Outputs)</span>
                                </label>
                                <div className="col-10">
                                    <textarea id="project_title" value={toEdit.project_title||''} className="form-control" name="project_title" onChange={handleChange} rows={3} required/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="ongoing_activities" className="col-2 col-form-label">
                                    <span>Ongoing Activities</span>
                                </label>
                                <div className="col-10">
                                    <textarea id="ongoing_activities" value={toEdit.ongoing_activities||''} className="form-control" name="ongoing_activities" onChange={handleChange} rows={2}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="project_region" className="col-2 col-form-label">
                                    <span>Project Region</span>
                                </label>
                                <div className="col-10">
                                    <textarea id="project_region" value={toEdit.project_region||''} className="form-control" name="project_region" onChange={handleChange} rows={2} maxLength={255} required/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="project_districts" className="col-2 col-form-label">
                                    <span>Project Cities, Districts</span>
                                </label>
                                <div className="col-10">
                                    <textarea id="project_districts" value={toEdit.project_districts||''} className="form-control" name="project_districts" onChange={handleChange} rows={2} maxLength={255}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="physical_objective" className="col-2 col-form-label">
                                    <span>Physical Objective</span>
                                </label>
                                <div className="col-10">
                                    <textarea id="physical_objective" value={toEdit.physical_objective||''} className="form-control" name="physical_objective" onChange={handleChange} rows={2}/>
                                </div>
                            </div>

                        </div>
                        <div className="col-6">

                            <div className="form-group row">
                                <label htmlFor="impl_period_from" className="col-2 col-form-label">
                                    <span>Implementation Period</span>
                                </label>
                                <div className="col-10">
                                    <div className="row">
                                        <div className="col-6">
                                            from: <input
                                                    id="impl_period_from"
                                                    value={
                                                        toEdit.impl_period_from && !isNaN(new Date(toEdit.impl_period_from))
                                                            ? new Date(toEdit.impl_period_from).toISOString().slice(0, 7)
                                                            : ""
                                                    }
                                                    required
                                                    className="form-control"
                                                    name="impl_period_from"
                                                    type="month"
                                                    onChange={handleChange}
                                                    style={{width:"200px"}}
                                            />
                                        </div>
                                        <div className="col-6">
                                            to: <input
                                                id="impl_period_to"
                                                value={toEdit.impl_period_to && !isNaN(new Date(toEdit.impl_period_to))
                                                    ? new Date(toEdit.impl_period_to).toISOString().slice(0, 7)
                                                    : ""
                                                }
                                                required
                                                className="form-control"
                                                name="impl_period_to"
                                                type="month"
                                                onChange={handleChange}
                                                style={{width:"200px"}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="grant_agrement_date" className="col-2 col-form-label">
                                    <span>Grant/ Loan agreement date</span>
                                </label>
                                <div className="col-10">
                                    <input id="grant_agrement_date" value={toEdit.grant_agrement_date||''} className="form-control" name="grant_agrement_date" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="project_cost" className="col-2 col-form-label">
                                    <span>Total Project Cost</span>
                                </label>
                                <div className="col-10">
                                    <input id="project_cost" value={toEdit.project_cost||''} className="form-control" name="project_cost" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="grant_loan_amount" className="col-2 col-form-label">
                                    <span>Grant/Loan Amount</span>
                                </label>
                                <div className="col-10">
                                    <input id="grant_loan_amount" value={toEdit.grant_loan_amount||''} className="form-control" name="grant_loan_amount" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="compl_date" className="col-2 col-form-label">
                                    <span>Expected Completion Date</span>
                                </label>
                                <div className="col-10">
                                    <input id="compl_date" value={toEdit.compl_date||''} className="form-control" name="compl_date" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="govern_commitment" className="col-2 col-form-label">
                                    <span>Government Commitment</span>
                                </label>
                                <div className="col-10">
                                    <input id="govern_commitment" value={toEdit.govern_commitment||''} className="form-control" name="govern_commitment" type="text" onChange={handleChange} maxLength={50}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="project_website" className="col-2 col-form-label">
                                    <span>Link to project website (if available)</span>
                                </label>
                                <div className="col-10">
                                    <input id="project_website" value={toEdit.project_website||''} className="form-control" name="project_website" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="contact_person" className="col-2 col-form-label">
                                    <span>Contact person for project </span>
                                </label>
                                <div className="col-10">
                                    <input id="contact_person" value={toEdit.contact_person||''} className="form-control" name="contact_person" type="text" onChange={handleChange} maxLength={255}/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="impl_status" className="col-2 col-form-label">
                                    <span>Implementation Status</span>
                                </label>
                                <div className="col-10">
                                    <input id="impl_status" value={toEdit.impl_status||''} className="form-control" name="impl_status" type="text" onChange={handleChange} maxLength={100}/>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="action-buttons">
                        <button type="submit" disabled={JSON.stringify(initialState) === JSON.stringify(toEdit)}>Save</button>
                        <button type="button" onClick={onClose}>Cancel</button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default EditProjectPopup;

